import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[glDropdownClick]',
    standalone: false
})
export class DropdownClickDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.outsideClickListener();
  }

  private outsideClickListener(): void {
    this.renderer.listen('window', 'click', (e: Event) => {
      const isDropdownClicked = this.el.nativeElement.contains(e.target);
      const liElement: HTMLElement = this.el.nativeElement;
      const openedDropdown: HTMLElement = this.el.nativeElement.querySelector('.active') as HTMLElement;
      if (!isDropdownClicked && openedDropdown) {
        this.renderer.removeClass(openedDropdown, 'active');
        this.renderer.removeClass(liElement, 'active');
      }
    });
  }

  @HostListener('click') onClick() {
    const liElement: HTMLElement = this.el.nativeElement;
    const element: HTMLElement = liElement.querySelector('.dropdown');
    const isActive: boolean = element.classList.contains('active');
    const parentElement = this.el.nativeElement.parentElement.parentElement.parentElement;
    const openedDropdowns = parentElement.querySelectorAll('.active');
    this.renderer.removeClass(liElement, 'active');
    openedDropdowns.forEach(dropdown => {
      this.renderer.removeClass(dropdown, 'active');
    });
    if (!isActive) {
      this.renderer.addClass(element, 'active');
      this.renderer.addClass(this.el.nativeElement, 'active');
    }
  }
}
